import { AccessControlledModel } from '../../models/AccessControlledModel';

export class FileModel extends AccessControlledModel {
	id: string = 'new' + (new Date().valueOf());
	public url: string | null; // CloudFront URL or permanent URL
	public objectStorageUrl: string | null; // S3 URL
	public key: string; // s3 key
}